import { ColumnHelperMethodType } from '../SearchContentTable.types';
import { getReachEngRate } from '../SearchContentTable.utils';
import { TextCell } from '../components/TextCell';

export const ColumnReachEngRate: ColumnHelperMethodType = (columnHelper) =>
  columnHelper.accessor((row) => row.contentId, {
    id: 'reachEngRate',
    cell: ({ row }) => <TextCell>{getReachEngRate(row.original)}</TextCell>,
    header: () => <>Reach Eng Rate</>,
  });
